// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"c7354f99","496":"6b3acd92"}[chunkId] + ".chunk.css";
};